<template>
  <div>
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group>
            <b-form-radio 
              v-model="filtro.filtroOpcion" 
              name="filtroOpcion" 
              :value="parseInt(1)"
              stacked>Filtro general</b-form-radio>

              <b-collapse 
                id="filtroOpcionGeneral" 
                class="mt-2" 
                v-model="showOpcionesGenerales">

                <b-form-group
                  label="Desde"
                  label-for="fechaDesde"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="fechaDesde" 
                    v-model="filtro.fechaDesde" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Hasta"
                  label-for="fechaHasta"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="fechaHasta" 
                    v-model="filtro.fechaHasta" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Transporte"
                  label-for="transporte"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="seleccionarTransporte">
                      <b-input-group-text>
                        <i :class="{ 'fa fa-search': !filtro.transporte,
                                      'fa fa-remove': filtro.transporte  }"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="transporte"
                      :value="transporteNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>  

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="entregaPersonal"
                      v-model="filtro.entregaPersonal"
                      :value="Boolean(true)"
                      :unchecked-value= "Boolean(false)">
                      Remitos con Entrega en persona
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  label="Cliente"
                  label-for="cliente"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="seleccionarCliente">
                      <b-input-group-text>
                        <i :class="{ 'fa fa-search': !filtro.cliente,
                                      'fa fa-remove': filtro.cliente  }"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="cliente"
                      :value="clienteNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  label="Destino"
                  label-for="remitoDestino"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="seleccionarRemitoDestino">
                      <b-input-group-text>
                        <i :class="{ 'fa fa-search': !filtro.remitoDestino,
                                      'fa fa-remove': filtro.remitoDestino  }"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="remitoDestino"
                      :value="remitoDestinoNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>  

                <b-form-group
                  label="Contacto"
                  label-for="contacto"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="contacto" 
                    v-model="filtro.contacto" 
                    type="text">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Provincia"
                  label-for="provincia"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="seleccionarProvincia">
                      <b-input-group-text>
                        <i :class="{ 'fa fa-search': !filtro.provincia,
                                      'fa fa-remove': filtro.provincia  }"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="provincia"
                      :value="provinciaNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>  

                <b-form-group
                  label="Localidad"
                  label-for="localidad"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="seleccionarLocalidad">
                      <b-input-group-text>
                        <i :class="{ 'fa fa-search': !filtro.localidad,
                                      'fa fa-remove': filtro.localidad  }"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="localidad"
                      :value="localidadNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>  

                <app-remito-estado
                  label="Estado"
                  :nombre="remitoEstadoNombre"
                  :lista="remitosEstadosList"
                  :label-cols="labelCols"
                  labelOption="Todos los estados"
                  :nullDisabled="false"
                  @updated="remitoEstadoActualizado">
                </app-remito-estado>  

                <app-usuario
                  label="Usuario"
                  :nombre="usuarioNombre"
                  :lista="usuariosList"
                  :label-cols="labelCols"
                  labelOption="Todos los usuarios"
                  :nullDisabled="false"
                  @updated="usuarioActualizado">
                </app-usuario>  

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="incluirAnulados"
                      v-model="filtro.incluirAnulados"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Incluir remitos anulados
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="sortByDescending"
                      v-model="filtro.sortByDescending"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Ordenar remitos en forma descendente
                  </b-form-checkbox>
                </b-form-group>
              </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroOpcion" 
              name="filtroOpcion" 
              :value="parseInt(2)"
              stacked>Filtro por presupuesto/orden</b-form-radio>

              <b-collapse 
                id="filtroOpcionPresupuesto" 
                class="mt-2" 
                v-model="showOpcionesPresupuesto">              

                <b-form-group
                  label="Nro. Presupuesto"
                  label-for="numeroPresupuesto"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="numero" 
                    v-model="filtro.numeroPresupuesto" 
                    type="text">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Nro. Orden"
                  label-for="numeroOrdenTrabajo"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="numero" 
                    v-model="filtro.numeroOrdenTrabajo" 
                    type="text">
                  </b-form-input>
                </b-form-group>

                <app-remito-estado-presupuesto
                  label="Estado"
                  :nombre="remitoEstadoPresupuestoNombre"
                  :lista="remitosEstadosList"
                  :label-cols="labelCols"
                  labelOption="Todos los estados"
                  :nullDisabled="false"
                  @updated="remitoEstadoPresupuestoActualizado">
                </app-remito-estado-presupuesto>  
              </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroOpcion" 
              name="filtroOpcion" 
              :value="parseInt(3)"
              stacked>Filtro por número</b-form-radio>

              <b-collapse 
                id="filtroOpcionNumero" 
                class="mt-2" 
                v-model="showOpcionesNumero">              

                <b-form-group
                  label="Nro. Punto Venta"
                  label-for="numeroPuntoVenta"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="numeroPuntoVenta" 
                    v-model="filtro.numeroPuntoVenta" 
                    type="text">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Nro. Remito"
                  label-for="numero"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="numero" 
                    v-model="filtro.numero" 
                    type="text">
                  </b-form-input>
                </b-form-group>
              </b-collapse>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <b-modal ref="searchRemitoDestinoModal" 
        title="Seleccionar Destino"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-remito-destino
        @remitoDestinoSeleccionado="remitoDestinoSeleccionado">
      </app-search-remito-destino>  
    </b-modal>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Transporte"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        :transportes="true"
        :incluirInactivos="true"
        @proveedorSeleccionado="transporteSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <b-modal ref="searchProvinciaModal" 
        title="Seleccionar Provincia"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-provincia
        :incluirInactivos="true"
        @provinciaSeleccionada="provinciaSeleccionada">
      </app-search-provincia>  
    </b-modal>

    <b-modal ref="searchLocalidadModal" 
        title="Seleccionar Localidad"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-localidad
        :incluirInactivos="true"
        @localidadSeleccionada="localidadSeleccionada">
      </app-search-localidad>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import SearchRemitoDestino from '../remitosdestinos/SearchList.vue';
import SearchProvincia from '../provincias/SearchList.vue';
import SearchLocalidad from '../localidades/SearchList.vue';
import SearchProveedor from '../proveedores/SearchList.vue';
import RemitoEstado from '../shared/abmSelect.vue';
import RemitoEstadoPresupuesto from '../shared/abmSelect.vue';
import Usuario from '../shared/abmSelect.vue';
import moment from 'moment';

export default {
  components: {
    appSearchCliente: SearchCliente,
    appSearchRemitoDestino: SearchRemitoDestino,
    appSearchProvincia: SearchProvincia,
    appSearchLocalidad: SearchLocalidad,
    appSearchProveedor: SearchProveedor,
    appRemitoEstado: RemitoEstado,
    appRemitoEstadoPresupuesto: RemitoEstadoPresupuesto,
    appUsuario: Usuario,
  },
  props: {
    filtroOpcion: {
      type: Number,
      default: 1,
    },
    fechaDesde: {
      type: String,
      default: ''
    },
    fechaHasta: {
      type: String,
      default: ''
    },
    cliente: {
      type: Object,
      default: null
    },
    remitoDestino: {
      type: Object,
      default: null
    },
    remitoEstado: {
      type: Object,
      default: null
    },
    contacto: {
      type: String,
      default: ''
    },
    provincia: {
      type: Object,
      default: null
    },
    localidad: {
      type: Object,
      default: null
    },
    numeroPresupuesto: {
      type: Number,
      default: 0
    },
    numeroOrdenTrabajo: {
      type: Number,
      default: 0
    },
    remitoEstadoPresupuesto: {
      type: Object,
      default: null
    },
    transporte: {
      type: Object,
      default: null
    },
    entregaPersonal: {
      type: Boolean,
      default: false,
    },
    usuario: {
      type: Object,
      default: null
    },
    incluirAnulados: {
      type: Boolean,
      default: false,
    },
    numero: {
      type: Number,
      default: 0
    },
    numeroPuntoVenta: {
      type: Number,
      default: 0
    },
    sortByDescending: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      filtro: {
        filtroOpcion: 1,

        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
        remitoDestino: null,
        remitoEstado: null,
        contacto: '',
        provincia: null,
        localidad: null,
        numeroPresupuesto: 0,
        numeroOrdenTrabajo: 0,
        remitoEstadoPresupuesto: null,
        transporte: null,
        entregaPersonal: false,
        usuario: null,
        incluirAnulados: false,
        sortByDescending: false,
        numero: 0,
        numeroPuntoVenta: 0,
      },
      usuarios: [],
      usuariosList: [],
      remitosEstados: [],
      remitosEstadosList: [],
      showOpcionesFiltro: Boolean(false),
      labelCols: 2,
      showOpcionesGenerales: true,
      showOpcionesPresupuesto: false,
      showOpcionesNumero: false,

    }
  },
  created() {
    this.filtro.filtroOpcion = this.filtroOpcion;
    this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD');
    this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD');
    this.filtro.cliente = this.cliente;
    this.filtro.remitoDestino = this.remitoDestino;
    this.filtro.remitoEstado = this.remitoEstado;
    this.filtro.contacto = this.contacto;
    this.filtro.provincia = this.provincia;
    this.filtro.localidad = this.localidad;
    this.filtro.numeroPresupuesto = this.numeroPresupuesto;
    this.filtro.numeroOrdenTrabajo = this.numeroOrdenTrabajo;
    this.filtro.remitoEstadoPresupuesto = this.remitoEstadoPresupuesto;
    this.filtro.transporte = this.transporte;
    this.filtro.entregaPersonal = this.entregaPersonal;
    this.filtro.usuario = this.usuario;
    this.filtro.incluirAnulados = this.incluirAnulados;
    this.filtro.sortByDescending = this.sortByDescending;
    this.filtro.numero = this.numero;
    this.filtro.numeroPuntoVenta = this.numeroPuntoVenta;
    this.getDatosAdicionales();
  },
  computed: {
    'clienteNombre': function() {
      return this.filtro.cliente? this.filtro.cliente.nombre.trim() : '';
    },
    'remitoDestinoNombre': function() {
      return this.filtro.remitoDestino? this.filtro.remitoDestino.nombre.trim() : '';
    },
    'remitoEstadoNombre': function() {
      return this.filtro.remitoEstado? this.filtro.remitoEstado.nombre.trim() : null;
    },
    'provinciaNombre': function() {
      return this.filtro.provincia? this.filtro.provincia.nombre.trim() : null;
    },
    'localidadNombre': function() {
      return this.filtro.localidad? this.filtro.localidad.nombre.trim() : null;
    },
    'transporteNombre': function() {
      return this.filtro.transporte? this.filtro.transporte.nombre.trim() : null;
    },
    'usuarioNombre': function() {
      return this.filtro.usuario? this.filtro.usuario.nombre.trim() : null;
    },
    'remitoEstadoPresupuestoNombre': function() {
      return this.filtro.remitoEstadoPresupuesto? this.filtro.remitoEstadoPresupuesto.nombre.trim() : null;
    },
  },     
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('usuarios/getList')
        .then(() => {
          this.usuarios = this.$store.getters['usuarios/list'];
          this.usuariosList = this.$store.getters['usuarios/selectList'];
        })
      this.$store.dispatch('remitosEstados/getList')
        .then(() => {
          this.remitosEstados = this.$store.getters['remitosEstados/list'];
          this.remitosEstadosList = this.$store.getters['remitosEstados/selectList'];
        })
    },
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.cliente = null;
      this.filtro.remitoDestino = null;
      this.filtro.remitoEstado = null;
      this.filtro.contacto = '';
      this.filtro.provincia = null;
      this.filtro.localidad = null;
      this.filtro.numeroPresupuesto = 0;
      this.filtro.numeroOrdenTrabajo = 0;
      this.filtro.remitoEstadoPresupuesto = null;
      this.filtro.entregaPersonal = false;
      this.filtro.usuario = null;
      this.filtro.incluirAnulados = false;
      this.filtro.numero = 0; 
      this.filtro.numeroPuntoVenta = 0; 
    },
    seleccionarCliente() {
      if (this.filtro.cliente) {
        this.filtro.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.filtro.cliente = cliente;
      this.$refs.searchClienteModal.hide();
    },
    seleccionarRemitoDestino() {
      if (this.filtro.remitoDestino) {
        this.filtro.remitoDestino = null;
      } else {
        this.$refs.searchRemitoDestinoModal.show();
      }
    },
    remitoDestinoSeleccionado(remitoDestino) {
      this.filtro.remitoDestino = remitoDestino;
      this.$refs.searchRemitoDestinoModal.hide();
    },
    seleccionarTransporte() {
      if (this.filtro.transporte) {
        this.filtro.transporte = null;
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    transporteSeleccionado(transporte) {
      this.filtro.transporte = transporte;
      this.$refs.searchProveedorModal.hide();
    },
    usuarioActualizado(usuarioNombre) {
      this.filtro.usuario= null;
      if (usuarioNombre) {
        this.filtro.usuario = this.getSelected(this.usuarios, usuarioNombre);
      }
    },
    seleccionarProvincia() {
      if (this.filtro.provincia) {
        this.filtro.provincia = null;
      } else {
        this.$refs.searchProvinciaModal.show();
      }
    },
    provinciaSeleccionada(provincia) {
      this.filtro.provincia = provincia;
      this.$refs.searchProvinciaModal.hide();
    },
    seleccionarLocalidad() {
      if (this.filtro.localidad) {
        this.filtro.localidad = null;
      } else {
        this.$refs.searchLocalidadModal.show();
      }
    },
    localidadSeleccionada(localidad) {
      this.filtro.localidad = localidad;
      this.$refs.searchLocalidadModal.hide();
    },
    remitoEstadoActualizado(remitoEstadoNombre) {
      this.filtro.remitoEstado= null;
      if (remitoEstadoNombre) {
        this.filtro.remitoEstado = this.getSelected(this.remitosEstados, remitoEstadoNombre);
      }
    },
    remitoEstadoPresupuestoActualizado(remitoEstadoPresupuestoNombre) {
      this.filtro.remitoEstadoPresupuesto= null;
      if (remitoEstadoPresupuestoNombre) {
        this.filtro.remitoEstadoPresupuesto = this.getSelected(this.remitosEstados, remitoEstadoPresupuestoNombre);
      }
    },
  },
  watch: {
    'filtro.filtroOpcion' : function(newVal, oldVal) {
      this.showOpcionesGenerales = parseInt(newVal) == 1? true : false;
      this.showOpcionesPresupuesto = parseInt(newVal) == 2? true : false;
      this.showOpcionesNumero = parseInt(newVal) == 3? true : false;
    },
  }    
}
</script>

<style>
</style>
